export default "__VITE_ASSET__qqJRVEh6aGlxhf56pSYIBA__";